"use strict";
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_document = void 0;
const objectToQueryString_1 = require("../../../helpers/objectToQueryString");
const store_1 = require("../../../store");
const api_1 = require("../../api");
function get_document(request) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const { userState } = store_1.redux_store.getState();
        const { token } = userState;
        // If status is known, use the correct endpoint directly
        if (request.status) {
            const endpoint = request.status === "DRAFT" ? `draft/document${(0, objectToQueryString_1.objectToQueryString)(request)}` : `document${(0, objectToQueryString_1.objectToQueryString)(request)}`;
            try {
                const response = yield new api_1.API().apiGet({
                    baseUrl: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : "",
                    endpoint,
                    authorization: `${token}`,
                });
                if (!response.success && response.status === 403) {
                    return Object.assign(Object.assign({}, response), { message: `Access denied. You may not have permission to view this document.` });
                }
                return response;
            }
            catch (error) {
                console.error("❌ Error fetching document:", error);
                return {
                    success: false,
                    message: "Failed to fetch document. Please try again.",
                    error: error,
                };
            }
        }
        // Status unknown: Try regular endpoint first (most documents are published)
        // This avoids unnecessary 403 errors in logs
        try {
            const response = yield new api_1.API().apiGet({
                baseUrl: (_b = process.env.API_URL) !== null && _b !== void 0 ? _b : "",
                endpoint: `document${(0, objectToQueryString_1.objectToQueryString)(request)}`,
                authorization: `${token}`,
            });
            if (response.success) {
                return response;
            }
        }
        catch (error) {
            // Regular endpoint failed, will try draft endpoint
        }
        // Try draft endpoint as fallback (for document owners viewing drafts)
        try {
            const draftResponse = yield new api_1.API().apiGet({
                baseUrl: (_c = process.env.API_URL) !== null && _c !== void 0 ? _c : "",
                endpoint: `draft/document${(0, objectToQueryString_1.objectToQueryString)(request)}`,
                authorization: `${token}`,
            });
            if (draftResponse.success) {
                return draftResponse;
            }
        }
        catch (error) {
            // Both endpoints failed
        }
        // Both endpoints failed
        return {
            success: false,
            message: "Access denied. You may not have permission to view this document.",
            status: 403,
        };
    });
}
exports.get_document = get_document;
